module.exports = __webpack_public_path__ + "static/media/logoRangoComercialBlanco.a78f6738.svg";